import React, { useState, useContext, useEffect } from 'react';
import './desarrolloHumano.scss';
import TeamCarousel from '../../../../../../Helpers/TeamCarousel';

// CONTEXT
import AboutusDepartmentsContext from '../../../../../../../contexts/pages/aboutus/departments/departmentsContext';

const DEFAULT_ORIENTACION_DESC = "Tiene como función principal acompañar y orientar los alumnos, junto a sus padres y maestros, en el proceso de crecimiento personal que implica desarrollo emocional, físico y espiritual.";

const DesarrolloHumano = () => {
    const aboutusDepartmentsContext = useContext(AboutusDepartmentsContext);
    const { departments } = aboutusDepartmentsContext;

    const [profiles, setProfiles] = useState(null);
    const [description, setDescription] = useState(DEFAULT_ORIENTACION_DESC);

    useEffect(() => {
        if (!departments || departments.length === 0) return;
        const normalize = (str) => (str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const currProfiles = departments.filter(value => normalize(value.titulo).includes('orientacion'));
        if (currProfiles.length > 0) {
            if (currProfiles[0].descripcion) {
                setDescription(currProfiles[0].descripcion);
            }
            if (currProfiles[0].tarjetas_personal) {
                setProfiles(currProfiles[0].tarjetas_personal);
            }
        }
    }, [departments]);

    return (
        <div className="human-dev-board">
            <div className="human-dev-board-inner">
                <div className="human-dev-board-title">ORIENTACIÓN</div>
                <div className="human-dev-board-text">
                    <p>
                        {description}
                    </p>
                </div>
            </div>
            <div className="human-dev-board-profiles-inner">
                {/* {profiles ? <HumanDevProfiles width={250} height={250} spacing={4} src={profiles} /> : null} */}
                {profiles ?   <TeamCarousel items={profiles}/>: null}
            </div>
        </div>
    )
}

export default DesarrolloHumano;